import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GlobalThemeOverride from './GlobalThemeOverride';
import ClientProvider from './client';
export default createDemo(import.meta.url, GlobalThemeOverride, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/theme-components/demos/global-theme-override/GlobalThemeOverride.tsx",
    "fileName": "GlobalThemeOverride.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\n\nconst theme = createTheme({\n  components: {\n    MuiButton: {\n      styleOverrides: {\n        root: {\n          fontSize: '1rem',\n        },\n      },\n    },\n  },\n});\n\nexport default function GlobalThemeOverride() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Button>font-size: 1rem</Button>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 22,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\n\nconst theme = createTheme({\n  components: {\n    MuiButton: {\n      styleOverrides: {\n        root: {\n          fontSize: '1rem',\n        },\n      },\n    },\n  },\n});\n\nexport default function GlobalThemeOverride() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={theme}>\n      <Button>font-size: 1rem</Button>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">font-size: 1rem</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 22,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
